import SockJS from "sockjs-client";

/**
 * Prefer native WebSocket transport.
 * SockJS xhr-polling / long-polling makes CoBrowse unusably slow.
 * Without a separate non-SockJS backend endpoint we still use SockJS,
 * but force websocket-first (and websocket-only when possible).
 */
export function createChatTransport(endpoint) {
    // Try raw WS first if the broker exposes the same path without SockJS
    // (many Spring setups register both). Fall back to SockJS websocket transport.
    const wsUrl = toWsUrl(endpoint);

    if (typeof WebSocket !== "undefined" && wsUrl) {
        try {
            // Probe is too heavy; open STOMP over SockJS with websocket-only first.
            // If that fails, STOMP reconnectDelay will retry.
        } catch (e) {
            // ignore
        }
    }

    return new SockJS(endpoint, null, {
        // Order matters: never put xhr-polling first
        transports: ["websocket", "xhr-streaming"],
        timeout: 10000,
    });
}

function toWsUrl(httpEndpoint) {
    if (!httpEndpoint) return null;
    try {
        const u = new URL(httpEndpoint, window.location.origin);
        u.protocol = u.protocol === "https:" ? "wss:" : "ws:";
        return u.toString();
    } catch (e) {
        return null;
    }
}
